import { createReducer } from '@reduxjs/toolkit'

import * as availableUnitsActions from '../../actions/AvailableUnits/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface IAvailableUnitsReducerType {
  data: string[]
  fetched: boolean
}

const INITIAL_STATE: IAvailableUnitsReducerType = {
  data: [],
  fetched: false
}

const availableUnitsReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(availableUnitsActions.getAll, (state) => {
      return {
        ...state,
        fetched: false
      }
    })
    .addCase(availableUnitsActions.getAllSuccess, (state, action) => {
      return {
        ...state,
        data: action.payload,
        fetched: true
      }
    })
    .addCase(availableUnitsActions.getAllFailed, (state) => {
      return {
        ...state,
        fetched: true
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default availableUnitsReducer
